import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import CookieConsent from '../components/CookieConsent'; // импорт
import { navItems } from '../data/navData';
import { galleryNavItems } from '../data/galleryNavData';

const PublicLayout = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  // Для путей, начинающихся с /gallery или /archived-news, используем сокращённое меню
  let currentNavItems = navItems;
  if (location.pathname.startsWith('/gallery') || location.pathname === '/archived-news') {
    currentNavItems = galleryNavItems;
  }

  return (
    <>
      <Header />
      <Navigation
        menuOpen={menuOpen}
        toggleMenu={toggleMenu}
        closeMenu={closeMenu}
        navItems={currentNavItems}
      />
      <Outlet />
      <Footer />
      <CookieConsent /> 
    </>
  );
};

export default PublicLayout;